/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTargetSelectData
 */
export interface OutputTargetSelectData {
    /**
     * 
     * @type {string}
     * @memberof OutputTargetSelectData
     */
    customTargetType: string;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetSelectData
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetSelectData
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetSelectData
     */
    targetType: number;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetSelectData
     */
    title: string;
}

/**
 * Check if a given object implements the OutputTargetSelectData interface.
 */
export function instanceOfOutputTargetSelectData(value: object): boolean {
    if (!('customTargetType' in value)) return false;
    if (!('description' in value)) return false;
    if (!('id' in value)) return false;
    if (!('targetType' in value)) return false;
    if (!('title' in value)) return false;
    return true;
}

export function OutputTargetSelectDataFromJSON(json: any): OutputTargetSelectData {
    return OutputTargetSelectDataFromJSONTyped(json, false);
}

export function OutputTargetSelectDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTargetSelectData {
    if (json == null) {
        return json;
    }
    return {
        
        'customTargetType': json['custom_target_type'],
        'description': json['description'],
        'id': json['id'],
        'targetType': json['target_type'],
        'title': json['title'],
    };
}

export function OutputTargetSelectDataToJSON(value?: OutputTargetSelectData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'custom_target_type': value['customTargetType'],
        'description': value['description'],
        'id': value['id'],
        'target_type': value['targetType'],
        'title': value['title'],
    };
}

